import {countdownTimer} from "../components/utils";
import {gsapContext} from "../components/theme-scripts";

export function singleProductInit() {

	gsapContext.add(() => {

		let productSlideshowSwiper = new Swiper('.product-slideshow .swiper', {
			slidesPerView: 1,
			spaceBetween:  0,
			speed:         600,
			autoHeight:    true,
			loop:          true,
			navigation:    {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}/*,
			pagination:    {
				el: ".swiper-pagination",
			}*/
		});


		let productSlideshowHighlightsSwiper = new Swiper('.product-slideshow-highlights .swiper', {
			slidesPerView: 1,
			speed:         600,
			autoHeight:    true,
			loop:          true,
			autoplay:      false,
			navigation:    {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination:    {
				el:        '.swiper-pagination',
				clickable: false
			},
			effect:        'fade',
			fadeEffect:    {
				crossFade: false
			},
			on:            {
				afterInit: function (swiper) {
					setTimeout(function(){
						productSlideshowHighlightsHeaderHeight(swiper)
					}, 100);
				},
				resize:    function (swiper) {
					productSlideshowHighlightsHeaderHeight(swiper);
				}
			}
		});

		function productSlideshowHighlightsHeaderHeight(swiper) {
			const swiperHeaders = swiper.el.querySelectorAll('.product-hl__header');
			let maxHeight = 0;

			swiperHeaders.forEach((item) => {
				if (item.offsetHeight > maxHeight)
				{
					maxHeight = item.offsetHeight;
				}
			});

			if (maxHeight > 0)
			{
				swiperHeaders.forEach((item) => {
					item.style.height = maxHeight + 'px';
				});
			}
		}


		let countdowns = document.querySelectorAll('.countdown');

		countdowns.forEach((el) => {
			countdownTimer(el.getAttribute('data-date'), el);
		});

	});
}